import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function YearsOfExperienceList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasyoeAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("year of experience");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasyoeEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("year of experience");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  const columns = [
    { field: "YEL_Id", label: "#" },
    { field: "YEL_Name", label: "Years of Experience" },
    { field: "YEL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hasyoeEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.YEL_Id));

        navigate(
          `/YearsOfExperienceLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean);

  return (
    <DynamicTable
      columns={columns}
      actions={actions}
      dataAPI={`/YearofExp/list`}
      title={`Years of Experience`}
      {...(hasyoeAddprivilege(privilegeData) && {
        linkvalue: `/YearsOfExperienceLookup/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default YearsOfExperienceList;
